import {useAuth} from "../store/auth-context";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {CircularProgress, Box} from "@mui/material";

const ProtectedRoute = (props) => {
    const { isAuthenticated, isLoading, user, isProfileComplete } = useAuth();
    const location = useLocation();
    const requiresAdmin = props.requireAdmin === true;

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/auth" />;
    }

    if (!isProfileComplete && location.pathname !== '/scheda-psicologo') {
        return <Navigate to="/scheda-psicologo" replace />;
    }

    if (requiresAdmin && (!user || user.role !== 'admin' || user.adminSessionActive !== true)) {
        return <Navigate to="/" />;
    }

    return <Outlet />;
}

export default ProtectedRoute;
